"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _constants = require("composer-plugins/lib/constants");

var _immutable = require("immutable");

var DEFAULTS = {
  authorId: null,
  order: '-updated',
  search: null,
  type: _constants.CLIP_TYPES.ALL
};

var ClipsFilter = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(ClipsFilter, _Record);

  function ClipsFilter() {
    (0, _classCallCheck2.default)(this, ClipsFilter);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ClipsFilter).apply(this, arguments));
  }

  (0, _createClass2.default)(ClipsFilter, null, [{
    key: "fromJS",
    value: function fromJS(data) {
      return new ClipsFilter(Object.assign({}, data));
    }
  }]);
  return ClipsFilter;
}((0, _immutable.Record)(DEFAULTS));

exports.default = ClipsFilter;
module.exports = exports.default;